import { useParams, useNavigate, Link } from 'react-router-dom'
import {
   useGetBankByIdQuery,
   useUpdateBankMutation,
} from '../../Redux/Service/BankApi'
import { toast } from 'react-toastify'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import StyledDashboardLayout from '../style'
import BankForm from './BankForm'
import { handleApiError } from '../../utils/apiErrorHandler'

function BankEdit() {
   const { id } = useParams()
   const navigate = useNavigate()

   const { data, isLoading, error } = useGetBankByIdQuery(id)
   const [updateBank] = useUpdateBankMutation()

   if (isLoading) return <div className="m-3">Loading...</div>
   if (error) return <div className="m-3">Failed to load bank</div>

   const bank = data.response
   // console.log('bank:', bank)

   const handleSubmit = async (values, { setSubmitting }) => {
      try {
         const payload = {
            bank_name: values.bank_name.trim(),
            account_no: values.account_no.trim(),
            account_type: values.account_type?.trim() || null,
            other_fields: (values.other_fields || []).map((item) => ({
               label: item.label.trim(),
               value: item.value.trim(),
            })),
         }
         const res = await updateBank({ id, payload }).unwrap()
         toast.success(res.message)
         navigate('/bank')
      } catch (error) {
         handleApiError(error)
      } finally {
         setSubmitting(false)
      }
   }

   return (
      <StyledDashboardLayout>
         <div className="content-wrapper">
            <div className="content-header d-flex justify-content-between m-3">
               <h1>Edit Bank</h1>
               <Link to="/bank" className="btn addBtn">
                  <ArrowBackIcon /> Back
               </Link>
            </div>

            <div className="card customCard p-3 m-3">
               <BankForm
                  initialValues={{
                     bank_name: bank.bank_name || '',
                     account_no: bank.account_no || '',
                     account_type: bank.account_type || '',
                     other_fields: bank.other_fields || [],
                  }}
                  onSubmit={handleSubmit}
                  submitLabel="Update"
               />
            </div>
         </div>
      </StyledDashboardLayout>
   )
}

export default BankEdit
